import {
  useMemo 
} from "react"
import {
  createPortal 
} from "react-dom"

const Portal = ({
  children, container 
}) => {
  const isServer = !globalThis.document

  const target = useMemo(() => {
    return isServer
      ? null
      : container instanceof HTMLElement
        ? container
        : document.getElementById("root")
  }, [container, isServer])

  return isServer ? null : createPortal(children, target)
}

export default Portal
